module.exports = __webpack_public_path__ + "static/media/OrdemServico6.6ca19fc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancOrdemServicos/OrdemServico6.png
// module id = 1769
// module chunks = 0